import axios from 'axios'
import { API_URL } from 'config'

function rpc () {
  let headers = {
    'Content-Type': 'application/json',
  }
  const instance = axios.create({
    baseURL: `${API_URL}`,
    headers: headers,
    withCredentials: true,
  })

  if (typeof document !== 'undefined') {
    const accessKey = localStorage.getItem("accessKey");
    if (accessKey !== '') {
      instance.defaults.headers.common['Authorization'] = `Token ${accessKey}`
    }
  }
  return instance
}

export function buildRequest(method, params) {
  return {
    jsonrpc: "2.0",
    id: "dontcare",
    method,
    params,
  }
}

export function signoutAndRedirectToIndex() {
  if (typeof document !== 'undefined') {
    window.localStorage.removeItem("accessKey")
    window.location.replace("/")
  }
}

/**
 * User-initiated logout. Best-effort rotates the DRF token server-side
 * via ``users.auth.logout`` so an intercepted token can no longer be
 * used, then clears local state via ``signoutAndRedirectToIndex``.
 *
 * Do **not** use this from 401/auth-error fall-through paths — those
 * should keep calling ``signoutAndRedirectToIndex`` directly. By the
 * time we get a 401 the token is already invalid; calling logout would
 * just return another 401.
 */
export async function userInitiatedLogout() {
  const client = rpc()
  try {
    await client.post('', buildRequest('users.auth.logout', {}))
  } catch (err) {
    // Network or backend failure must not block the local logout.
    console.warn('Server-side logout failed; clearing local state anyway.', err)
  }
  signoutAndRedirectToIndex()
}

export default rpc()
